import React from 'react';
import './ProductDetailImageList.scss';

import { connect } from 'react-redux';
import classNames from "classnames";

import {
    setElementProperty,
    setCustomText, instantUpload,
} from '../../actions';

//css and images
import OwlCarousel from "react-owl-carousel2";


class ProductDetailImageList extends React.PureComponent {

    addResiderToImageElements(props) {
        //var api_host = `${process.env.REACT_APP_API_HOST}`;
        let imageElements = props.imageElements;
        let hashes = Object.keys(imageElements);
        if (imageElements && hashes.length){
          hashes.map((hash)  => {
            if (imageElements[hash].photoUrl){
              if (imageElements[hash].photoUrl.indexOf(".svg") <0) {
                if (imageElements[hash].photoUrl.indexOf("https://jd-res.s3.ap-east-1.amazonaws.com/") !== -1) {
                  imageElements[hash].photoUrl=imageElements[hash].photoUrl.replace("https://jd-res.s3.ap-east-1.amazonaws.com/","https://d2b72aifdvmdso.cloudfront.net/production/")+"?width=74.25";
                }
              }
            }
          })
        }
        return imageElements;
    }

    render() {
        // if(!this.props.imageElements) {
        //     return '';
        // }
        const params = {
            items: 4,
            nav: true,
            rewind: false,
            autoplay: false,
            //lazyLoad: true,
            dots: false,
            loop: false,
            //singleItem: true,
            //autoWidth:true,
            navText: ['&lt;', '&gt;'],
            responsive: {
                0: {
                    items:3,
                },
                576: {
                    items:3,
                },
                769:{
                    items:4,
                },
                376:{
                    items:4,
                }
            }
        };

      //console.log('rerendering');
      let hashes = Object.keys(this.props.imageElements);
      return (<div>
          {(this.props.imageElements && hashes.length) ?
              <React.Fragment>
              <div className="row">
                  <div className="col-3 h6 font-weight-bold">Edit Images</div>
                  <div className="col-9">
                      <OwlCarousel ref="car" options={params}
                                   className={classNames("owl-carousel owl-theme owl-loaded owl-drag border owl-preset owl-grab owl-hover border-0", {'px-4 py-2' : hashes.length>4})}>
                          {
                              hashes.map(hash => (
                                      <div key={hash} className='d-flex' style={{'height':'74.25px', 'objectFit': 'fill'}}>
                                          <img data-src={(this.props.imageElements[hash].photoUrl.indexOf(".svg") <0 && this.props.imageElements[hash].photoUrl.indexOf("https://jd-res.s3.ap-east-1.amazonaws.com/") !== -1)?this.props.imageElements[hash].photoUrl.replace("https://jd-res.s3.ap-east-1.amazonaws.com/","https://d2b72aifdvmdso.cloudfront.net/production/")+"?width=74.25":this.props.imageElements[hash].photoUrl} src={(this.props.imageElements[hash].photoUrl.indexOf(".svg") <0 && this.props.imageElements[hash].photoUrl.indexOf("https://jd-res.s3.ap-east-1.amazonaws.com/") !== -1)?this.props.imageElements[hash].photoUrl.replace("https://jd-res.s3.ap-east-1.amazonaws.com/","https://d2b72aifdvmdso.cloudfront.net/production/")+"?width=74.25":this.props.imageElements[hash].photoUrl} width={74.25} className='border' onClick={(() => this.props.instantUpload(hash, this.props.imageElements[hash].photoUrl, this.props.imageElements[hash].height, this.props.imageElements[hash].width, this.props.imageElements[hash].filterName))}/>
                                      </div>

                                  )
                              )
                          }
                      </OwlCarousel>
                  </div>
                  <div className="w-100 d-block mt-2 border-top">&nbsp;</div>
              </div>
              </React.Fragment>
              :''}
        </div>)
    }
}

const mapStateToProps = state => {
    let imageElements = {};

    for(let page of state.pages) {
        for(let element of page.elements) {
            if (element.type === 'photo' && element.replaceable && element.photoUrl) {
                let newElement = JSON.parse(JSON.stringify(element));
                if (state.customTexts && state.customTexts[element.hash] && state.customTexts[element.hash].photoUrl) {
                    newElement = {...newElement, ...state.customTexts[element.hash]}
                }
                newElement = (({ photoUrl, hash, height, width, filterName }) => ({ photoUrl, hash, height, width, filterName }))(newElement);
                imageElements[element.hash] = newElement;
            }
        }
    }
  return {
    imageElements,
  }
};

const mapDispatchToProps = dispatch => ({
  setElementProperty: (elementHash, changes) => dispatch(setElementProperty(elementHash, changes)),
  setCustomText: (elementHash, newText) => dispatch(setCustomText(elementHash, newText)),
  instantUpload: (hash = null, preview_url = null, minHeight = null, minWidth = null, filterName = null) => dispatch(instantUpload(hash, preview_url, minHeight, minWidth, filterName)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetailImageList);
